// export const blogsEndPoint = 'http://localhost:1337'; // FIXME:  For testing only.  Remove this line when deploying.
export const blogsEndPoint = 'https://equinoblecms.herokuapp.com';
export const firebaseDynamicLinkPrefix = 'https://equinoble.page.link'; // FIXME:  For testing only.  Remove this line when deploying.
// export const firebaseDynamicLinkPrefix = 'https://equinobleapps.page.link'; // FIXME:  PRODUCTION
export const IOS_APP_STORE_ID = '1570926714';
export const ANDROID_PACKAGE_NAME = 'com.equinoble_app';
export const IOS_BUNDLE_IDENTIFIER = 'com.equinoble';